import React from 'react';

const PhoneLogo = (props) => {
	return (
		<div class="phone_logo mod_align_center">
			<svg width="30px" height="30px" viewBox="0 0 30 30">
				<g>
					<rect x="10.95" y="7.71" width="8.1" height="12.96"/>

					<circle cx="15" cy="22.7" r="1.22"/>

					<path d="M15,2.5C8.1,2.5,2.5,8.1,2.5,15c0,6.9,5.6,12.5,12.5,12.5c6.9,0,12.5-5.6,12.5-12.5C27.5,8.1,21.9,2.5,15,2.5zM19.86,23.02c0,0.94-0.76,1.7-1.7,1.7h-6.32c-0.94,0-1.7-0.76-1.7-1.7V6.98c0-0.94,0.76-1.7,1.7-1.7h6.32c0.94,0,1.7,0.76,1.7,1.7V23.02z"/>

					<path d="M13.38,6.7h3.24c0.11,0,0.2-0.09,0.2-0.2c0-0.11-0.09-0.2-0.2-0.2h-3.24c-0.11,0-0.2,0.09-0.2,0.2C13.18,6.6,13.27,6.7,13.38,6.7z"/>
				</g>
			</svg>
		</div>
	)
}

export default PhoneLogo;